export
{
	default as templateParser
}
from './es6/template parser'

export
{
	default as templateFormatter
}
from './es6/template formatter'

export
{
	default as InputController
}
from './es6/input controller'

export
{
	default as ReactInput
}
from './es6/react input'

export
{
	default as parseDigit
}
from './es6/parse digit'

export
{
	default as parse
}
from './es6/parse'

export
{
	default as format
}
from './es6/format'


//////////////////
// WEBPACK FOOTER
// ./~/input-format/index.es6.js
// module id = ./node_modules/input-format/index.es6.js
// module chunks = 0 1 2